import { render, staticRenderFns } from "./SmartwaiverWidget.vue?vue&type=template&id=596354ca&scoped=true&"
import script from "./SmartwaiverWidget.vue?vue&type=script&lang=ts&"
export * from "./SmartwaiverWidget.vue?vue&type=script&lang=ts&"
import style0 from "./SmartwaiverWidget.vue?vue&type=style&index=0&id=596354ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596354ca",
  null
  
)

export default component.exports